import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'

// Gli aggiornamenti del service worker sono gestiti da UpdatePrompt (toast + reload su conferma)

createRoot(document.getElementById("root")!).render(<App />);
